// Sentry  modules
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

const sentryRelease = (window as any).SENTRY_RELEASE;

if (sentryRelease) {
  let environment = "production";
  const { hostname } = window.location;
  if (/localhost/.test(hostname)) environment = "localhost";
  if (/staging/.test(hostname)) environment = "staging";
  if (/test/.test(hostname)) environment = "test";

  Sentry.init({
    dsn: "https://3c17c08030a97524499f9b2311503f33@o4509005379796992.ingest.de.sentry.io/4509005403258960",
    integrations: [new Integrations.BrowserTracing()],
    release: sentryRelease?.id,
    dist: (window as any).SENTRY_DIST,
    environment,
  });
}
